import axios from "axios";
import { baslakGistUrls as data } from "./baslak-gist-urls";

// Getting the JSON data on my account
export const getTrainingtimes = async () => {
  const response = await axios.get(data.traininghours);
  return response.data;
};

export const getAddress = async () => {
  const response = await axios.get(data.caliaddress);
  return response.data;
};

export const getLeaderboardRepetitions = async () => {
  const response = await axios.get(data.repetition);
  return response.data;
};

export const getLeaderboardDuration = async () => {
  const response = await axios.get(data.duration);
  return response.data;
};

export const getFAQ = async () => {
  const response = await axios.get(data.faq);
  return response.data;
};